import * as React from 'react'
import Popup from 'reactjs-popup'
import FormFields from '../resources_records/FormFields'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'

import { resources_records_path } from '../../routes'
import useResourcesRecordFormController from '../../hooks/useResourcesRecordFormController'
import { useCreateResourcesRecordMutation } from '../../hooks/queries/resources_records'
import CommonContext, { WarehouseType } from '../CommonContext'
import TemplateManager from '../resources_records/TemplateManager'
import { useContext } from 'react'

type NewTimeEntryButtonProps = {
  record: any
  availableWorktypes: any[]
  availableWorkcards: any[]
  availablePartners: any[]
  availableWarehouses: WarehouseType[]
  allPartners: any[]
  allowPartners: boolean
  availableMachines: any[]
  hideMachines?: boolean
  hideItems?: boolean
  hidePackagings?: boolean
  hideShipments?: boolean
  hidePurchases?: boolean
  buttonClass?: string
}

function NewTimeEntryButton(props: NewTimeEntryButtonProps) {
  const {
    record,
    availableWorktypes,
    availableWorkcards,
    availableWarehouses,
    availablePartners,
    allPartners,
    allowPartners,
    availableMachines,
    hideMachines,
    hideItems,
    hidePackagings,
    hideShipments,
    hidePurchases,
    buttonClass,
  } = props

  const dictionaries = useContext(CommonContext)
  const { currentUser, updateCurrentUser } = dictionaries
  const buttonTitle = 'Indtast tid'
  const { formData, setFormData, transform, successfullyCreated, setSuccessfullyCreated } = useResourcesRecordFormController(record)
  const mutation = useCreateResourcesRecordMutation(() => setSuccessfullyCreated(true))
  const handleSubmit = e => {
    e.preventDefault()
    mutation.mutate({ resources_record: transform(formData) })
  }

  return (
    <Popup
      trigger={
        <button type="button" className={buttonClass || 'btn btn-outline-secondary'}>
          {buttonTitle}
        </button>
      }
      position="center center"
      contentStyle={{ width: '100%', maxWidth: '720px', maxHeight: '100%', overflowX: 'hidden', overflowY: 'auto' }}
      onClose={() => setSuccessfullyCreated(false)}
      closeOnDocumentClick={false}
      modal
    >
      {closeModal => {
        return (
          <div className={`resources-record-modal modal-popup ${mutation.isLoading ? 'loading' : ''}`}>
            <a className="close" onClick={closeModal}>
              &times;
            </a>
            <div className="resources-record-modal-header popup-header">{buttonTitle}</div>
            <form onSubmit={handleSubmit} action={resources_records_path({ format: 'json' })} method="POST">
              <div className="resources-record-modal-content popup-content">
                {successfullyCreated && <div className="alert alert-success"> Record successfully created! </div>}
                {!successfullyCreated && (
                  <>
                    <TemplateManager
                      formData={formData}
                      setFormData={setFormData}
                      currentUser={currentUser}
                      updateCurrentUser={updateCurrentUser}
                    />
                    <FormFields
                      record={record}
                      formData={formData}
                      setFormData={setFormData}
                      availableWorktypes={availableWorktypes}
                      availableWorkcards={availableWorkcards}
                      availableWarehouses={availableWarehouses}
                      availablePartners={availablePartners}
                      availableMachines={availableMachines}
                      allPartners={allPartners}
                      allowPartners={allowPartners}
                      hideMachines={hideMachines}
                      hideItems={hideItems}
                      hidePackagings={hidePackagings}
                      hideShipments={hideShipments}
                      hidePurchases={hidePurchases}
                    />
                  </>
                )}
              </div>
              {mutation.isError && (
                <div className="resources-record-modal-error">
                  <ErrorMessage className="d-inline error-message" error={mutation.error} isError={mutation.isError} />
                  <div>Make sure you have all fields properly filled and try again.</div>
                </div>
              )}
              <div className="resources-record-modal-actions popup-actions">
                <button type="button" className="btn btn-outline-secondary" onClick={closeModal}>
                  Luk
                </button>
                {!successfullyCreated && (
                  <button type="submit" className="btn btn-primary" disabled={mutation.isLoading}>
                    {mutation.isLoading ? <i className="fa fa-spinner fa-spin" /> : 'Save'}
                  </button>
                )}
              </div>
            </form>
          </div>
        )
      }}
    </Popup>
  )
}

export default NewTimeEntryButton
